// @flow

import { authenticatedFetch } from '../../../api/request';

export default function getCustomAttributionLinks() {
    return authenticatedFetch('/v5/marketplace/attributions');
}
